// Product brief for Lincoln MoneyGuard Fixed Advantage. See cmTwo.ts for format.

export const lincolnMoneyGuardBrief = `**Lincoln MoneyGuard Fixed Advantage** — asset-based hybrid UL with an LTC
benefits rider (LTCBR). Same broad two-pool, face-first shape as OneAmerica
Asset Care, with Lincoln's own indemnity cap.

Pool model — two pools, drawn in order:
- **Face / Specified Amount** is the \`base_pool\`, drawn FIRST. On this product
  the Face is the death benefit and the at-issue LTC acceleration portion. If
  LTCBR inflation fields are present, LTC pool/cap growth follows the header
  rates while the death benefit remains flat. Prior utilization is subtracted at
  init.
- **Continuation of Benefits (COB)** is the \`eob\` column, drawn only after the
  Face pool is exhausted.

Death benefit:
- **Flat Face — never inflated.** LTC reimbursements reduce the death benefit
  dollar-for-dollar by the **Face (base) drawdown only**; COB drawdown does NOT
  reduce it. Floored at the Residual DB (minimum guaranteed, ~5% of Face).
  Remaining DB at the horizon is a non-LTC return.

Payout model — reimbursement (default) or cash indemnity:
- **Reimbursement** (default): pays min(eligible cost, pro-rated cap), drawing
  Face then COB.
- **Indemnity** (first-claim election, claim-wide and irrevocable): pays cash
  regardless of actual cost, capped by \`policyIndemnityBenefitPercent\` (80% on
  the mapped MoneyGuard illustration; defaults to 100% for hand-entered policies
  with no percent). MoneyGuard has ONE LTC rider, so the indemnity election pays
  from BOTH pools — Face first, then COB — at the same cap until the total LTC
  benefit is exhausted; it NEVER reverts to reimbursement on COB. Cash above the
  eligible cost banks as a surplus reserve, drained on later shortfall months.

Elimination period:
- **No retroactive WP lump.** Elimination-period days are out-of-pocket.

Things to eyeball:
- Face depletes before any COB drawdown — \`eob\` stays flat until \`base_pool\` is 0.
- Indemnity rows pay the indemnity % (80% on the mapped illustration) of the
  pro-rated cap, from Face then COB, until the total benefit exhausts — never
  reverting to reimbursement on COB.
- Death benefit falls only with Face drawdown, never with COB, and never inflates.
- DB stops falling once it reaches the residual floor.
`;
